<template>
    <div class="pages">
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <ul class="pages__menu">
                        <li
                            v-for="tab in tabs"
                            :key="tab.id"
                            @click="setActiveTab(tab)"
                        >
                            <a
                                href="javascript:void(0)"
                                :class="{ current: activeTab?.id === tab.id }"
                            > {{ tab.name }}
                            </a>
                        </li>
                    </ul>
                </div>

                <KeepAlive class="tab-content">
                    <component :is="activeTab.component" />
                </KeepAlive>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import Pages from "./Pages.vue";
import Menus from "./Menus.vue";
import News from "./News.vue";

export default defineComponent({
    name: "AdminPanel.vue",
    components: {Pages},
    data() {
        return {
            activeTab: null,
            tabs: [
                {
                    id: 1,
                    name: 'Pages',
                    component: () => import('./Pages.vue')
                },
                {
                    id: 2,
                    name: 'Menus',
                    component: () => import('./Menus.vue')
                },
                {
                    id: 3,
                    name: 'News',
                    component: () => import('./News.vue')
                }
            ],
        }
    },
    methods: {
        getActiveTab() {
            const urlParams = new URLSearchParams(window.location.search);
            const tabParam = urlParams.get('tab');

            if (tabParam) {
                const foundTab = this.tabs.find(tab => tab.name === tabParam);
                if (foundTab) {
                    this.activeTab = foundTab;
                    return;
                }
            }
            this.activeTab = this.tabs[0];
        },
        setActiveTab(tab) {
            this.activeTab = tab;
            window.history.pushState({ tab: tab.name }, "", `?tab=${tab.name}`);
        },
    },
    created() {
        this.getActiveTab();
    }
})
</script>



<style scoped>

</style>
